// extracted by mini-css-extract-plugin
module.exports = {"wrap":"he-z","heading":"ie-z"};